/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FavoriteListResponse } from '../models/FavoriteListResponse';
import type { FavoriteSortBy } from '../models/FavoriteSortBy';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FavoriteService {
    /**
     * List Favorites
     * @param sortBy
     * @param cursor
     * @returns FavoriteListResponse Successful Response
     * @throws ApiError
     */
    public static listFavoritesApiFavoriteListGet(
        sortBy?: FavoriteSortBy,
        cursor?: (string | null),
    ): CancelablePromise<FavoriteListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/favorite/list',
            query: {
                'sort_by': sortBy,
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Favorited Me
     * @param sortBy
     * @param cursor
     * @returns FavoriteListResponse Successful Response
     * @throws ApiError
     */
    public static listFavoritedMeApiFavoriteListFavoritedMeGet(
        sortBy?: FavoriteSortBy,
        cursor?: (string | null),
    ): CancelablePromise<FavoriteListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/favorite/list-favorited-me',
            query: {
                'sort_by': sortBy,
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Mark Favorite Seen
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static markFavoriteSeenApiFavoriteUserIdMarkSeenPost(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/favorite/{user_id}/mark-seen',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Favorite User
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static favoriteUserApiFavoriteUserIdPost(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/favorite/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Unfavorite User
     * @param userId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static unfavoriteUserApiFavoriteUserIdDelete(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/favorite/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
